export { default } from "./ListHistoricoVentasSemana";
